var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-development-page"},[_c('img',{attrs:{"src":require("../../../assets/images/man-construction.png"),"alt":""}}),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('in_dev_text')))])])}
var staticRenderFns = []

export { render, staticRenderFns }